import axios from 'axios';

export default axios.create({
  baseURL: "https://api.mojiokokun.jp",
  headers: {
    'Content-Type': 'application/json',
  }
});
